<template>

  <div >
    <Header ref="header" ></Header>

    <div class="conversion">
      <div data-v-108d3240="" data-v-25858e0c="" class=" banner" style="">
        <div class="w banner_bg pad20">
          <div data-v-108d3240="" class="container mx-auto px-4 py-10" style="width:auto !important;">
            <div data-v-108d3240="" class="flex-column">

              <h1 data-v-108d3240="" class="white" style="font-size: 48px;">
                图片无损放大
              </h1>
              <div data-v-108d3240="" class="  mb-10 font-light">
                <div class="linehei2 pad fs20 white">
                  <p>专业技术一键无损放大照片，令人震撼的画质效果</p>
                  <p>AI智能处理强力降噪，修复图片放大后的噪点和锯齿</p>
                  <p>不损失图像质量，支持放大2倍、4倍、8倍和16倍</p>
                </div>
              </div>
              <div class="">
                <button  @click="$router.push('/tabs/imgbig')" class="btn-ani  shadow-xl px-6 text-lg py-3 text-afb-light border border-white bg_orange  rounded " style="padding:15px 80px;">
                  上传图片
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="w">
           <div class="fs30 pad20 flex-center bold mt25 mb20">专业图像放大，清晰修复功能强大</div>

           <div class="flex-space">
             <div class="radius-20 flex-column bg_white pad mr10 shadow_big">
               <div class="fs20 pad">图片无损放大</div>
               <div class="fs20 gray999 pad">AI智能修复技术一键无损放大图片，批量操作快速优化，提高工作效率</div>

               <img src="../assets/images/imgbig/fangda_def@2x.jpg" class="lr10 mb10" style="width:550px;"/>
             </div>
             <div class="flex-column">
               <div class="radius-20 flex-column bg_white pad shadow_big">
                 <div class="fs20 pad">图片清晰度修复</div>
                 <div class="fs20 gray999 pad">优化图像纹理细节/文字增强，修复图像模糊细节，使照片更加自然清晰</div>
                 <img src="../assets/images/imgbig/imgbig_yhqh.jpg" class="lr10 mb10"  style="width:95%;"/>
               </div>
               <div class="radius-20 flex-column bg_white pad mt15 shadow_big">
                 <div class="fs20 pad">人像智能美化</div>
                 <div class="fs20 gray999 pad">多维度AI智能高清修复，快速修复细节填充，优化图像使其达到最佳效果</div>
                 <img src="../assets/images/imgbig/imgbig_yhqh2.jpg" class="lr10 mb10"  style="width:95%;"/>
               </div>
             </div>
           </div>

      </div>

      <div class="flex-center mt25">
        <button  @click="$router.push('/tabs/imgbig')"  class="btn-ani  shadow-xl px-6 text-lg py-3 text-afb-light border border-white bg_blue  rounded " style="padding:15px 80px;">
          上传图片
        </button>
      </div>

      <div class="w mt25">
         <div class="fs30 pad20 flex-center bold mt15 mb15">45无损放大功能特性</div>
         <div class="fs20  pad gray666">

              <p class="acenter">帮助您在不损失质量的情况下放大图像尺寸，减少噪音和锐化 </p>
              <p class="acenter">提高图像质量，使用嗨格式图片无损放大器，轻松提高图像质量，操作简单，方便省时。</p>
         </div>

        <div class="flex-space-wrap mt25">
            <div style="width:50%">
              <div class="border-blue bg_gray_blue pad20 mr20 mt20 flex-1">
                <img src="../assets/images/imgbig/texing_icon_01@2x.png" class="pic-80 ml15" />
                <div class="fs18 linehei2 ml15 mt4">
                  <div class="fs18">AI图像智能放大</div>
                  <div class="fs14 ">在不损失质量的情况下放大图像，支持放大200%和400%</div>
                </div>
              </div>
            </div>
          <div style="width:50%">
            <div class="border-blue bg_gray_blue pad20  mt20 flex-1">
              <img src="../assets/images/imgbig/texing_icon_01@2x.png" class="pic-80 ml15" />
              <div class="fs18 linehei2 ml15 mt4">
                <div class="fs18">AI图像智能放大</div>
                <div class="fs14 ">在不损失质量的情况下放大图像，支持放大200%和400%</div>
              </div>
            </div>
          </div>
          <div style="width:50%">
            <div class="border-blue bg_gray_blue pad20 mr20 mt20 flex-1">
              <img src="../assets/images/imgbig/texing_icon_01@2x.png" class="pic-80 ml15" />
              <div class="fs18 linehei2 ml15 mt4">
                <div class="fs18">AI图像智能放大</div>
                <div class="fs14 ">在不损失质量的情况下放大图像，支持放大200%和400%</div>
              </div>
            </div>
          </div>
          <div style="width:50%">
            <div class="border-blue bg_gray_blue pad20  mt20 flex-1">
              <img src="../assets/images/imgbig/texing_icon_01@2x.png" class="pic-80 ml15" />
              <div class="fs18 linehei2 ml15 mt4">
                <div class="fs18">AI图像智能放大</div>
                <div class="fs14 ">在不损失质量的情况下放大图像，支持放大200%和400%</div>
              </div>
            </div>
          </div>





        </div>

      </div>

      <div class="bg_white pad20">
        <div class="w mt25">
          <div class="fs30 pad20 flex-center bold mt15 mb15">使用场景</div>
          <img src="../assets/images/imgbig/imgbig_cj.jpg" class="w100">


        </div>
        <div class="flex-center mt25">
          <button  @click="$router.push('/tabs/imgbig')"  class="btn-ani  shadow-xl px-6 text-lg py-3 text-afb-light border border-white bg_blue  rounded " style="padding:15px 80px;">
            上传图片
          </button>
        </div>

        <div class="w mt25">
          <div class="fs30 pad20 flex-center bold mt15 mb15">网站操作步骤</div>
          <div class="flex-space">
              <div class="relative">
                  <img src="../assets/images/imgbig/buzhou_anzhuang@2x.png" style="width: 190px;" />
                  <div class="linehei1_5">
                    <div class="bold fs18 acenter">登录注册</div>
                    <div class="fs14 acenter gray666">首先登录注册您的账号</div>
                  </div>
                  <img class="bz_jd2" src="../assets/images/imgbig/buzhou_jindu@2x.png">
              </div>
            <div class="relative">
              <img src="../assets/images/imgbig/buzhou_tianjia@2x.png" style="width: 190px;" />
              <div class="linehei1_5">
                <div class="bold fs18 acenter">添加图片</div>
                <div class="fs14 acenter gray666">添加需要放大操作的图片</div>
              </div>
              <img class="bz_jd2" src="../assets/images/imgbig/buzhou_jindu@2x.png" >
            </div>
            <div class="relative">
              <img src="../assets/images/imgbig/buzhou_xuanze@2x.png" style="width: 190px;" />
              <div class="linehei1_5">
                <div class="bold fs18 acenter">批量选择</div>
                <div class="fs14 acenter gray666">勾选需要放大的模式放大倍数、降噪等级</div>
              </div>
              <img class="bz_jd2" src="../assets/images/imgbig/buzhou_jindu@2x.png" >
            </div>
            <div class="relative">
              <img src="../assets/images/imgbig/buzhou_wancheng@2x.png" style="width: 190px;" />
              <div class="linehei1_5">
                <div class="bold fs18 acenter">立即使用</div>
                <div class="fs14 acenter gray666">勾选对应文件后开始操作即可完成</div>
              </div>
            </div>

          </div>
        </div>



      </div>













    </div>

    <Foot ref="foot" ></Foot>
  </div>
</template>

<script>
  import Header from "./header";
  import Foot from "./foot";
  export default {
    //name: "Home_hm",
    components: { Header:Header,Foot:Foot},
    data() {

      return {
        url:"",
        time: 0,
        radio: 3,
      }
    },
    mounted() {
      const token = this.$storeLocal.get('token');
      const user_info = this.$storeLocal.get('userInfo');
      const times = Date.parse(new Date())/1000;

      if (token !== null && token !== '' && token !== undefined) {
        if (user_info.expire_date > times){
          this.isVip = true;
        }
        this.isGuest = false;
        this.user_info = user_info;
      }

    },

    methods: {

      change(){
        console.log('111')
      },


    }


  }
</script>

<style>
  .app{
    background-color: #eee;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    color: #ffffff;
  }
  .agreement{
    color: #409EFF;
    font-weight: 500;
    cursor: pointer;
  }
  button {
    cursor: pointer;
  }
  .line-bottom {
    border-bottom: 1px solid #FFFFFF;
  }
  .gray-back {
    background-color: #F5F5F5!important;
  }
  /*浮动导航*/
  .float-nav-box {
    width: 80px;
    height: auto;
    background-color: #008DF2;
    color: #FFFFFF;
    position: fixed;
    top: 50%;
    right: 0;
    margin-top: -230px;
    padding: 0 10px;
  }

  .float-nav-box .div-box {
    width: 100%;
    height: 70px;
    text-align: center;
    padding-top: 22px;
    cursor: pointer;
  }

  .float-nav-box .div-box i {
    font-size: 30px;
  }

  .float-nav-box .div-box .qrcode-box {
    width: 160px;
    height: 190px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px #D9D9D9;
    border-radius: 8px;
    display: none;
  }

  .float-nav-box .div-box:hover .qrcode-box{
    display: block;
  }

  .float-nav-box .div-box .app-qrcode {
    position: absolute;
    top: 0;
    left: -190px;
  }

  .float-nav-box .div-box .gzh-qrcode {
    position: absolute;
    top: 100px;
    left: -190px;
  }

  .float-nav-box .div-box .kf-qrcode {
    position: absolute;
    top: 190px;
    left: -190px;
  }

  .float-nav-box .div-box .sw-qrcode {
    position: absolute;
    top: 280px;
    left: -190px;
  }

  .float-nav-box .div-box .qrcode-box .img-box {
    width: 140px;
    height: 170px;
    /*z-index: 99;*/
    position: absolute;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
  }

  .float-nav-box .div-box .qrcode-box .img-box img {
    width: 140px;
    height: 140px;
  }

  .float-nav-box .div-box .qrcode-box .img-box div {
    width: 140px;
    height: 20px;
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #333333;
    margin-top: 5px;
  }

  .float-nav-box .div-box .qrcode-box span {
    display: block;
    position: absolute;
    top: 30px;
    right: -10px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 10px #D9D9D9;
    background-color: #ffffff;
    transform: rotate(45deg);
    /*z-index: 88;*/
  }


  .conversion {
    width: 100%;
  }


  .conversion .features .input-box input {
    width: 570px;
    height: 41px;
    font-size: 30px;
    border: 1px #BFBFBF solid;
    border-right: 0;
    vertical-align: bottom;
  }

  .conversion .features .input-box button {
    width: 120px;
    height: 45px;
    outline: none;
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
  }

  .conversion .features .input-box a {
    width: 120px;
    height: 45px;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
    display: inline-block;
    line-height: 45px;
  }


  .conversion .box {
    width: 100%;
    background-color: #ffffff;
  }


  .conversion .box .management .icon-box div {
    width: 25%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    color: #333333;
    font-size: 18px;
  }

  .conversion .box .management .icon-box div i {
    font-size: 60px;
  }


  .conversion .box .management .remark div {
    width: 23%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #666666;
    padding: 0 1%;
    text-align: left;
  }


  .conversion .box .control .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .control .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }

  .conversion .box .controls .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .controls .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }

  .conversion .boxs .contact .icon-box div {
    width: 240px;
    height: 100%;
    display: inline-block;
    vertical-align: top;
  }


  .conversion .boxs .contact .icon-box div .icons i {
    line-height: 90px;
    font-size: 40px;
  }


  .conversion .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .conversion .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }

  .conversion .box .copyright div span {
    display: inline-block;
    padding: 0 10px;
  }

  .conversion .box .copyright div span a {
    color: #666666;
  }


  .conversion .box .list-box .link-list a {
    color: #00aaee;
  }

  .conversion .box .list-box .link-list table {
    border-bottom: 1px solid #e6e6e6;
    width: 978px;
    table-layout: fixed;
  }

  .conversion .box .list-box .link-list tr th {
    border-top: 1px solid #e6e6e6;
    padding: 0 5px;
    color: #333;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: #f5f5f5;
    font-weight: normal;
    line-height: 34px;
  }

  .conversion .box .list-box .link-list tr td {
    border-top: 1px solid #e6e6e6;
    padding: 10px 5px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .conversion .box .list-box .link-list tr:hover td {
    background-color: #f2faff;
  }

  .conversion .box .list-box .link-list .refresh button {
    width: 100px;
    height: 40px;
    display: block;
    font-size: 16px;
    color: #fff;
    border: none;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    background-color: #008df2;
    border-radius: 5px;
  }

  .conversion .box .list-box .link-list .refresh button:hover {
    opacity: .8;
    filter: alpha(opacity=80);
  }

  .conversion .box .message_intro .introduce a {
    width: 30%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 20px;
    color: #666666;
    padding: 0 1%;
    text-align: left;

  }

  .contactusdiyou .hoverbtn span {
    width: 30px;
    height: 19px;
    line-height: 19px;
    text-align: center;
    overflow: hidden;
    float: left;
  }

  .contactusdiyou .conter .con1 dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }


  .kefuQQ a {
    background: url(../assets/images/index/button-custom-qq.gif) no-repeat;
    width: 70px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .kefuQQ a:hover {
    background: url(../assets/images/index/button-custom-qq-h.gif) no-repeat;
  }

  .contactusdiyou .qqcall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall .f3 img {
    width: 150px;
    height: auto;
  }

  .contactusdiyou .dytimer span {
    display: block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #fff;
  }

  .userProtocol .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }

  .userProtocol .box {
    width: 100%;
  }


  .userProtocol .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .userProtocol .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }


  .userProtocol .box .copyright div span a {
    color: #666666;
  }

  .userProtocol h3, h1 {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .userProtocol h1 {
    font-size: 25px;
    text-align: center;
    margin-bottom: 25px;
  }

  .userProtocol ol {
    margin-bottom: 20px;
    text-indent: 2em;
    line-height: 25px
  }



  .problem .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }

  .problem .problem-style li {
    font-size: 16px;
    line-height: 30px
  }

  .problem .problem-style .problem-img img {
    height: 800px;
    width: 90%
  }

  /*浮动导航*/
  .float-nav-box {
    width: 80px;
    height: auto;
    background-color: #008DF2;
    color: #FFFFFF;
    position: fixed;
    top: 50%;
    right: 0;
    margin-top: -230px;
    padding: 0 10px;
  }

  .float-nav-box .div-box {
    width: 100%;
    height: 70px;
    text-align: center;
    padding-top: 22px;
    cursor: pointer;
  }

  .float-nav-box .div-box i {
    font-size: 30px;
  }

  .float-nav-box .div-box .qrcode-box {
    width: 160px;
    height: 190px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px #D9D9D9;
    border-radius: 8px;
    display: none;
  }

  .float-nav-box .div-box:hover .qrcode-box{
    display: block;
  }

  .float-nav-box .div-box .app-qrcode {
    position: absolute;
    top: 0;
    left: -190px;
  }

  .float-nav-box .div-box .gzh-qrcode {
    position: absolute;
    top: 100px;
    left: -190px;
  }

  .float-nav-box .div-box .kf-qrcode {
    position: absolute;
    top: 190px;
    left: -190px;
  }


  .float-nav-box .div-box .qrcode-box .img-box {
    width: 140px;
    height: 170px;
    /*z-index: 99;*/
    position: absolute;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
  }

  .float-nav-box .div-box .qrcode-box .img-box img {
    width: 140px;
    height: 140px;
  }

  .float-nav-box .div-box .qrcode-box .img-box div {
    width: 140px;
    height: 20px;
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #333333;
    margin-top: 5px;
  }

  .float-nav-box .div-box .qrcode-box span {
    display: block;
    position: absolute;
    top: 30px;
    right: -10px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 10px #D9D9D9;
    background-color: #ffffff;
    transform: rotate(45deg);
    /*z-index: 88;*/
  }

  .line-bottom {
    border-bottom: 1px solid #FFFFFF;
  }

  /*api文档*/
  .user-console .u-rig {
    width: 1200px;
    min-height: 780px;
    margin: 0 auto;
  }

  .user-console h2.title {
    border-left: 4px solid #008bff;
    height: 20px;
    line-height: 20px;
    padding-left: 5px;
    margin: 10px 0 20px 0;
    font-size: 22px;
    font-weight: 500;
  }

  .icon-blue{
    color: #008df2;
  }
  .banner{color:#000;background:#008DF2;}
  .banner_bg {
    background:url(../assets/images/imgbig/imgbig_banner.png)  no-repeat right top;
    background-size: 47%
  }
  .h-80 {
    height: 20rem;
  }


  .text-afb-gray {
    --tw-text-opacity: 1;
    color: rgba(47,73,94,var(--tw-text-opacity));
  }


  .py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .container {
    width: 100%;
  }
  .justify-center {
    justify-content: center;
  }
  .items-center {
    align-items: center;
  }
  .flex-col {
    flex-direction: column;
  }
  .h-60 {
    height: 15rem;
  }
  .flex {
    display: flex;
  }

  .font-light {
    font-weight: 300;
  }
  .mb-10 {
    margin-bottom: 2.5rem;
  }
  .mt-5 {
    margin-top: 1.25rem;
  }
  .btn-ani {
    -webkit-animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
    animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
  }
  .btn-ani {
    -webkit-animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
    animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);
  }
  .shadow-xl {
    box-shadow: var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow);
  }

  .py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .bg-white {
    --tw-bg-opacity: 1;
    background-color: rgba(255,255,255,var(--tw-bg-opacity));
  }
  .border-white {
    --tw-border-opacity: 1;
    border-color: rgba(255,255,255,var(--tw-border-opacity));
  }
  .border {
    border-width: 1px;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .w-44 {
    width: 11rem;
  }


  .container {
    /*max-width: 640px;*/
  }
  .container {
    width: 100%;

  }
  .text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .mt-10 {
    margin-top: 2.5rem;
  }
  /*.border-afb-light, .hover\:border-afb-light:hover {*/
  /*   --tw-border-opacity: 1;*/
  /*  border-color: rgba(61,88,219,var(--tw-border-opacity));*/
  /*}*/

  .rounded-3xl {
    border-radius: 1.5rem;
  }

  .cursor-pointer {
    cursor: pointer;
  }


  .w-full {
    width: 100%;
  }

  .relative {
    position: relative;
  }

  .sm\:block {
    display: block;
  }
  .hidden {
    display: none;
  }

  .left-0 {
    left: 0;
  }

  .text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .mt-8 {
    margin-top: 2rem;
  }

  .text-white {
    --tw-text-opacity: 1;
    color: rgba(255,255,255,var(--tw-text-opacity));
  }
  .py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .bg-afb-light {
    --tw-bg-opacity: 1;
    background-color: rgba(61,88,219,var(--tw-bg-opacity));
  }
  .text-gray-500 {
    --tw-text-opacity: 1;
    color: rgba(107,114,128,var(--tw-text-opacity));
  }

  .text-xl {
    font-size: 1.25rem;
  }

  .text-center {
    text-align: center;
  }

  .border {
    border-width: 1px;
    border: #0a9dc7;
  }
  .sm\:flex {
    display: flex;
  }
  .pb-24 {
    padding-bottom: 6rem;
  }

  .mb-12 {
    margin-bottom: 3rem;
  }
  .mt-20 {
    margin-top: 5rem;
  }
  .main[data-v-8aa184b6] {
    width: 1000px;
  }

  .shadow-afb-bg {
    --tw-shadow: 0 0 50px rgba(56,100,137,0.1);
  }
   .shadow-afb-bg {
    box-shadow: var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow);
  }

  .pb-5 {
    padding-bottom: 1.25rem;
  }
  .px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .mt-24 {
    margin-top: 6rem;
  }
  .border-afb-light, .hover\:border-afb-light:hover {
    --tw-border-opacity: 1;
    border-color: rgba(61,88,219,var(--tw-border-opacity));
  }

  .border {
    border-width: 1px;
  }

  .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .mb-4 {
    margin-bottom: 1rem;
  }
  .mt-4 {
    margin-top: 1rem;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
  .el-form-item:after, .el-form-item:before {
    display: table;
    content: "";
  }
  [data-v-8aa184b6] .el-form-item__label {
    text-align: left;
  }

  .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }


  .el-form-item__content:after, .el-form-item__content:before {
    display: table;
    content: "";
  }
  .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;
  }
  .el-form-item__content:after {
    clear: both;
  }
  .el-form-item:after {
    clear: both;
  }
  .el-form-item {
    margin-bottom: 22px;
  }

  .text-left {
    text-align: left;
  }
  .flex-col {
    flex-direction: column;
  }
  [data-v-8aa184b6] .el-form-item__label {
    text-align: left;
  }

  .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  .ml-4 {
    margin-left: 1rem;
  }
  .el-icon-s-opportunity:before {
    content: "\e7aa";
  }


  .font-normal {
    font-weight: 400;
  }
  .font-normal {
    font-weight: 400;
  }
  .text-ss {
    font-size: .66666666rem;
  }
  table {
    border-collapse: collapse;
  }
  table {
    text-indent: 0;
    border-color: inherit;
  }
  .el-form-item__content {
    line-height: 40px;
    position: relative;
    font-size: 14px;
  }
  .text-center {
    text-align: center;
  }
  .bg-indigo-50 {
    --tw-bg-opacity: 1;
    background-color: rgba(238,242,255,var(--tw-bg-opacity));
  }

  .border-dashed {
    border-style: dashed;
    border-color: rgb(46, 106, 177);
  }
  .border-2 {
    border-width: 2px;
  }
  .select-none {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
  el-form-item:after, .el-form-item:before {
    display: table;
    content: "";
  }
  .font-bold {
    font-weight: 700;
  }
  .mr-4 {
    margin-right: 1rem;
  }
  .pb-32 {
    padding-bottom: 8rem;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .justify-between {
    justify-content: space-between;
  }
  .summary[data-v-657275de] {
    width: 100%;
    height: 280px;
    background: url(../assets/res/images/footer_bg.png) 50% no-repeat;
  }
  .to-blue-400 {
    --tw-gradient-to: #60a5fa;
  }
  .from-blue-600 {
    --tw-gradient-from: #2563eb;
    --tw-gradient-stops: var(--tw-gradient-from),var(--tw-gradient-to,rgba(37,99,235,0));
  }
  .bg-gradient-to-br {
    background-image: linear-gradient(to bottom right,var(--tw-gradient-stops));
  }
  .justify-center {
    justify-content: center;
  }
  .sm\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .ml-40 {
    margin-left: 10rem;
  }
  .text-afb-light {
    --tw-text-opacity: 1;
    color: rgba(61,88,219,var(--tw-text-opacity));
  }
  .text-lg, .text-xl {
    line-height: 1.75rem;
  }
  .text-lg {
    font-size: 1.125rem;
  }
  .el-tabs--border-card>.el-tabs__header{
    background-color: #ffffff;
    border-bottom: 0px;
    margin: 0;
    border-radius: 50px;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    border: #2e6ab1 1px solid;
    height: 48px;
    line-height: 40px;

  }
  .el-tabs__item {
     /*padding: 0 80px;*/
     height: 44px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    position: relative;
    border: 0px;
  }
  .el-tabs__nav {
    width: 100%;
    white-space: nowrap;
    position: relative;
    transition: -webkit-transform .3s;
    -webkit-transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    transition: transform .3s,-webkit-transform .3s;
    float: left;
    z-index: 0;
    line-height: 48px;
  }
  tabs__item.is-top:nth-child(2) {
     padding-left: 20%;
  }
  tabs__item.is-top:nth-child(2) {
    /* padding-left: 0; */
  }
  .el-tabs__item{line-height: 48px;}
  .el-tabs--bottom .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
     /*padding-left: 80px;*/
  }
  .el-tabs--top .el-tabs__item.is-top:last-child {
     /*padding-right: 80px;*/
  }
  .el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:last-child, .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
    /*padding-right: 80px;*/
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #e7ebfd;
    font-weight: 600;
    color: rgba(61,88,219,var(--tw-text-opacity));
    border-radius: 50px;
    height: 48px;

     color: #409EFF;
     /*background-color: #FFF;*/
    /*border-right-color: #DCDFE6;*/
    /*border-left-color: #DCDFE6;*/
  }
  .app{
    background-color: #ffffff;
  }
  .gold {
    color: #FFD700;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: #ffffff;
  }

  button {
    cursor: pointer;
  }

  .blue-btn {
    background-color: #008DF2;
  }

  .green-btn {
    background-color: #07CC00;
  }

  .gray-back {
    background-color: #F5F5F5!important;
  }

  .pl-10 {
    padding-left: 10%;
  }


  .conversion {
    width: 100%;
  }

  .conversion .features .input-box input {
    width: 570px;
    height: 41px;
    font-size: 30px;
    border: 1px #BFBFBF solid;
    border-right: 0;
    vertical-align: bottom;
  }

  .conversion .features .input-box button {
    width: 120px;
    height: 45px;
    outline: none;
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
  }

  .conversion .features .input-box a {
    width: 120px;
    height: 45px;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
    display: inline-block;
    line-height: 45px;
  }


  .conversion .box {
    width: 100%;
    background-color: #ffffff;
  }



  .conversion .box .management .icon-box div {
    width: 25%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    color: #333333;
    font-size: 18px;
  }

  .conversion .box .management .icon-box div i {
    font-size: 60px;
  }



  .conversion .box .management .remark div {
    width: 23%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #666666;
    padding: 0 1%;
    text-align: left;
  }



  .conversion .box .control .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .control .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }


  .conversion .box .controls .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .controls .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }



  .conversion .boxs .contact .icon-box div {
    width: 240px;
    height: 100%;
    display: inline-block;
    vertical-align: top;
  }

  .conversion .boxs .contact .icon-box div .icons i {
    line-height: 90px;
    font-size: 40px;
  }


  .conversion .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .conversion .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }

  .conversion .box .copyright div span {
    display: inline-block;
    padding: 0 10px;
  }

  .conversion .box .copyright div span a {
    color: #666666;
  }


  .conversion .box .list-box .link-list a {
    color: #00aaee;
  }

  .conversion .box .list-box .link-list table {
    border-bottom: 1px solid #e6e6e6;
    width: 978px;
    table-layout: fixed;
  }

  .conversion .box .list-box .link-list tr th {
    border-top: 1px solid #e6e6e6;
    padding: 0 5px;
    color: #333;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: #f5f5f5;
    font-weight: normal;
    line-height: 34px;
  }

  .conversion .box .list-box .link-list tr td {
    border-top: 1px solid #e6e6e6;
    padding: 10px 5px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .conversion .box .list-box .link-list tr:hover td {
    background-color: #f2faff;
  }



  .conversion .box .list-box .link-list .refresh button {
    width: 100px;
    height: 40px;
    display: block;
    font-size: 16px;
    color: #fff;
    border: none;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    background-color: #008df2;
    border-radius: 5px;
  }

  .conversion .box .list-box .link-list .refresh button:hover {
    opacity: .8;
    filter: alpha(opacity=80);
  }



  .conversion .box .message_intro .introduce a {
    width: 30%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 20px;
    color: #666666;
    padding: 0 1%;
    text-align: left;

  }



  .contactusdiyou .hoverbtn span {
    width: 30px;
    height: 19px;
    line-height: 19px;
    text-align: center;
    overflow: hidden;
    float: left;
  }



  .contactusdiyou .conter .con1 dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }



  .kefuQQ a {
    background: url(../assets/images/index/button-custom-qq.gif) no-repeat;
    width: 70px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .kefuQQ a:hover {
    background: url(../assets/images/index/button-custom-qq-h.gif) no-repeat;
  }





  .contactusdiyou .qqcall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }


  .contactusdiyou .weixincall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall .f3 {
    float: right;
    width: 73px;
    height: auto;
    margin-right: 69px;
    display: inline;
  }

  .contactusdiyou .weixincall .f3 img {
    width: 150px;
    height: auto;
  }



  .contactusdiyou .dytimer span {
    display: block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #fff;
  }
  /*用户协议*/
  .userProtocol {
  }

  .userProtocol .bg-color {
    background-color: white;
    width: 1200px;
    height: 60px;
    text-align: center;
  }

  .userProtocol .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }


  .userProtocol .box {
    width: 100%;
  }


  .userProtocol .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .userProtocol .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }


  .userProtocol .box .copyright div span a {
    color: #666666;
  }

  .userProtocol h3, h1 {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .userProtocol h1 {
    font-size: 25px;
    text-align: center;
    margin-bottom: 25px;
  }

  .userProtocol ol {
    margin-bottom: 20px;
    text-indent: 2em;
    line-height: 25px
  }


  /*问题*/

  .problem .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }



  .problem .problem-style .problem-text {
    font-size: 16px;
    text-indent: 2em;
    margin: 15px 15px;
  }

  .problem .problem-style li {
    font-size: 16px;
    line-height: 30px
  }


  .problem .problem-style .problem-img img {
    height: 800px;
    width: 90%
  }

  /*浮动导航*/
  .float-nav-box {
    width: 80px;
    height: auto;
    background-color: #008DF2;
    color: #FFFFFF;
    position: fixed;
    top: 50%;
    right: 0;
    margin-top: -230px;
    padding: 0 10px;
  }

  .float-nav-box .div-box {
    width: 100%;
    height: 70px;
    text-align: center;
    padding-top: 22px;
    cursor: pointer;
  }

  .float-nav-box .div-box i {
    font-size: 30px;
  }

  .float-nav-box .div-box .qrcode-box {
    width: 160px;
    height: 190px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px #D9D9D9;
    border-radius: 8px;
    display: none;
  }

  .float-nav-box .div-box:hover .qrcode-box{
    display: block;
  }

  .float-nav-box .div-box .app-qrcode {
    position: absolute;
    top: 0;
    left: -190px;
  }

  .float-nav-box .div-box .gzh-qrcode {
    position: absolute;
    top: 100px;
    left: -190px;
  }

  .float-nav-box .div-box .kf-qrcode {
    position: absolute;
    top: 190px;
    left: -190px;
  }

  .float-nav-box .div-box .sw-qrcode {
    position: absolute;
    top: 280px;
    left: -190px;
  }

  .float-nav-box .div-box .qrcode-box .img-box {
    width: 140px;
    height: 170px;
    /*z-index: 99;*/
    position: absolute;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
  }

  .float-nav-box .div-box .qrcode-box .img-box img {
    width: 140px;
    height: 140px;
  }

  .float-nav-box .div-box .qrcode-box .img-box div {
    width: 140px;
    height: 20px;
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #333333;
    margin-top: 5px;
  }

  .float-nav-box .div-box .qrcode-box span {
    display: block;
    position: absolute;
    top: 30px;
    right: -10px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 10px #D9D9D9;
    background-color: #ffffff;
    transform: rotate(45deg);
    /*z-index: 88;*/
  }

  .line-bottom {
    border-bottom: 1px solid #FFFFFF;
  }




  .qrCode{
    width: 200px;
    height: 200px;
    margin: 0 auto;
    border: 1px solid #d7dae2;
    position: relative;
  }
  .header-right .item a{
    color: #666666;
  }
  .vcode{
    width: 200px;
    margin-right: 20px;
  }
  .sendBtn{
    width: 140px;
  }
  .login_btn{
    width: 100%;
  }
  .box-card{
    width: 400px;
    /*height: 500px;*/
    margin: 100px auto;

  }
  .countdown{
    width: 100%;
    height: 30px;
    font-size: 14px;

    text-align: center;
  }
  .code-div{
    width: 100%;
    height: 100%;

  }
  .image-slot{
    width: 200px;
    height: 200px;
    text-align: center;
    line-height: 200px;
    background-color: rgba(0,0,0,0.1);
    position: absolute;
    top: 0;
    left: 0;
  }
  .image-slot i{
    color: #808080;
    font-size: 50px;
  }
  .agreement{
    color: #409EFF;
    font-weight: 500;
    cursor: pointer;
  }
  .copyright{
    width: 100%;
    color: #666666;
    text-align: center;
  }
  .captcha-img{
    display: inline-block;
    width: 110px;
    height: 36px;
    padding: 2px 0;
    margin-left: 10px;
    vertical-align: top;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item+.el-tabs__item, .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child {
     margin-left: 0px;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
    transition: all .3s cubic-bezier(.645,.045,.355,1);
     border: 0px ;
     margin-top: 0px;
    color: #909399;
  }

  .bz_jd2{position: absolute;left:200px;top:80px;width:120px;}
</style>
